module.exports = __webpack_public_path__ + "img/digital05.70433c6e.png";